import { ServiceType, ServiceTypeStr } from '@common/enums';

export interface DeleteBackupPayload {
  UserIds: string[];
  Email: boolean;
  Drive: boolean;
  Contact: boolean;
  Calendar: boolean;
  TeamDrive: boolean;
  SharePoint: boolean;
  Password: string;
}

export interface AddAlternateEmail {
  confirmPassword: string;
  email: string;
  password: string;
  userId: string;
}

export interface AddAltEmailPayload {
  ConfirmPassword: string;
  Email: string;
  Password: string;
  UserId?: string;
}

export interface AltAccPatch {
  deleteTwoStep?: {
    password: string;
  };
  editTwoStep?: {
    password: string;
    responseCode: string;
  };
}

export interface UserServiceBackupInfo {
  LastBackupDate: string;
  TotalSize: number;
}

export interface UserInfoForService extends UserServiceBackupInfo {
  Email: string;
  Id: string;
  InBackup?: boolean;
  Name: string;
  UserProviderState?: string;
}

export class ServiceFields {
  ServiceTypeStr = '';

  constructor(serviceType: ServiceType) {
    if (serviceType == ServiceType.Mail) {
      this.ServiceTypeStr = ServiceTypeStr.Mail;
    }

    if (serviceType == ServiceType.Drive) {
      this.ServiceTypeStr = ServiceTypeStr.Drive;
    }

    if (serviceType == ServiceType.Calendar) {
      this.ServiceTypeStr = ServiceTypeStr.Calendar;
    }

    if (serviceType == ServiceType.Contacts) {
      this.ServiceTypeStr = ServiceTypeStr.Contacts;
    }
  }
}
